import { API } from './config';

function interceptor() {
  function request(config) {
    /*  eslint no-param-reassign: off */
    if (/admin/.test(config.url) || /api/.test(config.url)) {
      config.url = `${API}${config.url}`;
    }
    return config;
  }
  return { request };
}
export default interceptor;



// WEBPACK FOOTER //
// ./client/app/common/config/interceptor.js